<div class="ds-card">
  <div class="inyova-grow-project-top">
    <div *ngIf="project.image" class="project-image">
      <img [src]="project.image" alt="Project image" />
    </div>
    <app-ds-badge *ngIf="badge.type !== 'hidden'" [type]="badge.type">
      {{ 'GROW.project.customerInvestmentStatus.' + badge.key + '.name' | translate }}
    </app-ds-badge>
    <h4 class="ds-caption-1"><span [innerHTML]="project.title"></span></h4>
    <app-ds-progress-bar [type]="projectStageProgress.type" [percentage]="projectStageProgress.percentage"></app-ds-progress-bar>
    <p class="ds-caption-3">{{ 'GROW.project.stage.' + project.stage + '.name' | translate }}</p>
  </div>

  <div class="inyova-grow-project-bottom">
    <p class="ds-ui-3">{{ project.expected_return | percent: '1.2' }} {{ 'GROW.project.perAnnum' | translate }}</p>
    <p class="ds-ui-3">{{ 'GROW.project.until' | translate }} {{ project.end_date | dateTranslate: 'shortMonth' : language }}</p>

    <app-ds-button size="small" [variant]="investable ? 'primary' : 'outline'" [isLoading]="isLoading">
      {{
        (investable
          ? groupedInvestments[0].status === growProjectStatus.COMMITTED || groupedInvestments[0].status === growProjectStatus.INVESTED
            ? 'GROW.project.buttons.investMore'
            : 'GROW.project.buttons.finishInvestment'
          : 'GROW.project.buttons.viewDetails'
        ) | translate
      }}
    </app-ds-button>
  </div>
</div>
